var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXlsx(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 5.76191V60.2381C16.5 63.4203 19.0394 66 22.1719 66H60.3281C63.4606 66 66 63.4203 66 60.2381V15.162C66 13.6229 65.3938 12.1477 64.3166 11.0654L54.9611 1.66529C53.8993 0.598393 52.4661 0 50.9726 0H22.1719C19.0394 0 16.5 2.57969 16.5 5.76191ZM20.1094 60.2381V5.76191C20.1094 4.60474 21.0328 3.66667 22.1719 3.66667H50.2734V16.2381C50.2734 18.4078 52.0048 20.1667 54.1406 20.1667H62.3906V60.2381C62.3906 61.3953 61.4672 62.3333 60.3281 62.3333H22.1719C21.0328 62.3333 20.1094 61.3953 20.1094 60.2381ZM62.3906 16.5V15.162C62.3906 14.6023 62.1702 14.0659 61.7785 13.6723L53.8828 5.739V16.2381C53.8828 16.3827 53.9982 16.5 54.1406 16.5H62.3906Z",
    fill: "#9D9C9B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2812 27.0703C42.2812 26.0736 43.0892 25.2656 44.0859 25.2656H55.9453C56.942 25.2656 57.75 26.0736 57.75 27.0703C57.75 28.067 56.942 28.875 55.9453 28.875H44.0859C43.0892 28.875 42.2812 28.067 42.2812 27.0703Z",
    fill: "#69C997"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2812 35.3203C42.2812 34.3236 43.0892 33.5156 44.0859 33.5156H55.9453C56.942 33.5156 57.75 34.3236 57.75 35.3203C57.75 36.317 56.942 37.125 55.9453 37.125H44.0859C43.0892 37.125 42.2812 36.317 42.2812 35.3203Z",
    fill: "#54AD7D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.2812 43.5703C42.2812 42.5736 43.0892 41.7656 44.0859 41.7656H55.9453C56.942 41.7656 57.75 42.5736 57.75 43.5703C57.75 44.567 56.942 45.375 55.9453 45.375H44.0859C43.0892 45.375 42.2812 44.567 42.2812 43.5703Z",
    fill: "#2B593D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0 19.0781C0 17.3695 1.38512 15.9844 3.09375 15.9844H34.0312C35.7399 15.9844 37.125 17.3695 37.125 19.0781V50.0156C37.125 51.7243 35.7399 53.1094 34.0312 53.1094H3.09375C1.38512 53.1094 0 51.7243 0 50.0156V19.0781Z",
    fill: "#3D8A58"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3125 44.9037L16.1072 34.1179L10.8483 24.2344H14.8524L18.2503 30.8751L21.5777 24.2344H25.5396L20.2806 34.2729L26.0753 44.9037H21.9443L18.1798 37.7554L14.4153 44.9037H10.3125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsx);
export default __webpack_public_path__ + "static/media/xlsx.7dbbefba2df4fc2d480d94f93bb74862.svg";
export { ForwardRef as ReactComponent };